import { getBuiltinProp } from "building-types/props/getBuiltinPropLibrary";
import TaskQueue from "common/utils/taskQueue";
import THREEAssetLoader from "gfx/THREEAssetLoader";

const PROP_PREFETCH_CONCURRENCY = 3;

const prefetchedAssetIds = new Set<number | string>();
const prefetchQueue = new TaskQueue<void>(PROP_PREFETCH_CONCURRENCY);

/**
 * Warm THREEAssetLoader's URL-keyed GLTF cache for builtin prop assets so the import's
 * renderGLTFProps hits cache instead of fetching over the network. Resolution mirrors
 * loadAndRenderPropInstance in gfx/gltf/gltfBuildingImporter.ts so cache keys match.
 * Fire-and-forget; failures fall back to the normal load path during import.
 */
export function prefetchShowroomPropAssets(assetIds: readonly (number | string)[]): void {
  for (const assetId of assetIds) {
    // Only builtin (numeric) prop assets have a known URL ahead of time.
    if (typeof assetId !== "number" || prefetchedAssetIds.has(assetId)) {
      continue;
    }
    prefetchedAssetIds.add(assetId);
    void prefetchQueue
      .enqueue(async () => {
        const propAsset = await getBuiltinProp(assetId);
        if (!propAsset) {
          return;
        }
        void (await THREEAssetLoader.instance.loadPropAssetGltf(propAsset));
      })
      .catch(() => undefined);
  }
}
